import React from 'react';
import GridDuck from 'gridduck';
import BreadcrumbService from "../../meta/breadcrumb-service";
import history from "../../meta/history";

class SiteGroupSites extends React.Component {
	constructor(props) {
		super(props);
		let {itemId} = this.props.match.params;
		BreadcrumbService.siteGroup = itemId;
		this.getList = this.getList.bind(this);
		this.goToSite = this.goToSite.bind(this);
		this.getAvailableList = this.getAvailableList.bind(this);
		this.save = this.save.bind(this);
		this.accountUpdated = this.accountUpdated.bind(this);
		let self = this;
		this.state = {
			siteGroupId: itemId
		}
		
		GridDuck.getAccount({id: GridDuck.userId})
			.then(function (account) {
				self.account = account;
				self.setState({account: account});
				// self.account.on('updated', self.accountUpdated);
			})
	}

	accountUpdated() {
		this.setState({account: this.account});
	}

	async getList(retrievalParams) {
		let paramsFromComponent = retrievalParams.filters || []
		retrievalParams.filters = paramsFromComponent.concat(this.props.listFilters || []);
		return GridDuck.getSites(retrievalParams);
	}

	save(newSites, itemsToAddRemove) {
		let newSiteIds = this.props.item.siteIds.filter(siteId => !itemsToAddRemove.itemsToRemove.find(i => i.id === siteId)).concat(itemsToAddRemove.itemsToAdd.map(i => i.id));
		return this.props.item.setSiteIds(newSiteIds);
	}

	goToSite(site) {
		history.push("/site/" + site.id);
	}

	getAvailableList(retrievalParams) {
		return GridDuck.getSites(retrievalParams);
	}

	componentWillUnmount() {
		if (this.account && this.account.off) {
			this.account.off('updated', this.accountUpdated);
		}
	}
}

export default SiteGroupSites;